import { Navigate, Outlet, useLocation } from '@tanstack/react-router';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/features/auth/hooks/useAuth';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    // Save intended destination for post-login redirect
    return <Navigate to="/login" search={{ redirect: location.pathname }} />;
  }

  return <Outlet />;
}
